<template>
  <section class="py-9 tablet:py-20">
    <div class="container-wrap">
      <div class="desktop:flex desktop:gap-6">
        <div class="desktop:w-1/3">
          <h2 class="text-h2 mb-10 tablet:line-clamp-2">
            {{ title }}
          </h2>
          <TheRichText
            v-if="descriptionHtml || description"
            class="mb-6 w-full text-sm leading-6 text-gray-700 tablet:mb-10 tablet:line-clamp-7 tablet:text-base"
            :text="descriptionHtml || description"
            :is-html="!!descriptionHtml"
          />
        </div>

        <ul class="desktop:w-2/3">
          <li
            v-for="(item, index) in items"
            :key="hash(item)"
            class="w-full border-b border-solid border-gray-400 py-5 first:pt-0"
          >
            <SectionAccordion02Card
              :item-data="item"
              :item-index="index"
              :default-open="defaultOpenAll || index === 0"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=12796-23840&t=89PIFDiQEC4zcSbf-0
   */

  import hash from 'object-hash';

  import type { IButton, TTheme } from '@/assets/types/Main.global';

  interface IItem {
    name: string;
    description?: string;
    link?: IButton;
  }

  interface IProps {
    title: string;
    description?: string;
    descriptionHtml?: string;
    items: IItem[];
    defaultOpenAll?: boolean;
    theme?: TTheme;
  }

  withDefaults(defineProps<IProps>(), {
    description: '',
    descriptionHtml: '',
    items: () => [],
    defaultOpenAll: false,
    theme: 'blue',
  });

  export type { IItem };
</script>
